import { getDataDashboard, getDataTabChart, getDataTopSearch } from 'Modules/dashboard/store/actions'
import reducer from 'Modules/dashboard/store/reducer'
import saga from 'Modules/dashboard/store/saga'
import { makeSelectDashboardMain } from 'Modules/dashboard/store/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { useInjectReducer, useInjectSaga } from 'Stores'

export const useDashboardMain = () => {
  useInjectSaga({ key: 'dashboardMain', saga })
  useInjectReducer({ key: 'dashboardMain', reducer })

  const { isLoading, topSearch, dataDashboard, dataChartTab } = useSelector(
    makeSelectDashboardMain()
  )

  const dispatch = useDispatch()
  const getDataDashboardAction = (payload) => dispatch(getDataDashboard(payload))
  const getDataTabChartAction = (payload) => dispatch(getDataTabChart(payload))
  const getDataTopSearchAction = (payload) => dispatch(getDataTopSearch(payload))

  return {
    topSearch,
    dataChartTab,
    isLoading,
    dataDashboard,
    getDataDashboardAction,
    getDataTabChartAction,
    getDataTopSearchAction
  }
}
